<template>
  <Popover v-if="typeof credits?.credits == 'number'" v-slot="{ open }">
    <PopoverTrigger class="h-10">
      <div
        :class="{ 'bg-background-secondary': open }"
        class="text-[#344054] text-label-prominent-md flex gap-x-1 items-center px-1 py-2.5 hover:bg-background-secondary rounded-lg"
      >
        <Icon height="20" icon="mingcute:ai-line"></Icon>
        <div class="flex items-center">
          <div class="overflow-hidden">
            <div class="odometer">
              <div
                v-for="(d, i) in credits?.credits?.toString().split('')"
                :key="i"
                class="digit-container"
              >
                <div
                  class="digit-roll"
                  :style="{
                    transform: `translateY(-${d * 1}em)`,
                  }"
                >
                  <!-- list 0–9 twice so it can roll past 9→0 smoothly if you want -->
                  <span v-for="n in 20" :key="n">
                    {{ (n - 1) % 10 }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <span>
            /{{
              subscriberType == "max-yearly"
                ? 2400 + credits?.topup
                : subscriberType == "max-monthly"
                  ? 200 + credits?.topup
                  : 6
            }}
          </span>
        </div>
      </div>
    </PopoverTrigger>
    <PopoverContent>
      <div>
        <h3>
          {{
            subscriberType == "max-yearly" || subscriberType == "max-monthly"
              ? "Credits Info"
              : "Free AI Credits"
          }}
        </h3>
        <p class="text-text-secondary text-body-sm mt-1">
          {{
            subscriberType == "max-yearly" || subscriberType == "max-monthly"
              ? "Your credits will renew at the start of new subscription cycle"
              : "Your free AI credits summary"
          }}
        </p>
        <div class="mt-5 flex gap-x-4 w-full">
          <div class="p-2 border rounded-lg flex-grow">
            <h4 class="text-text-secondary">
              {{ $t("navbar.CreditsUsed", "CreditsUsed") }}
            </h4>
            <div
              class="bg-background-error-light text-text-error px-3 py-2 rounded-md mt-2"
            >
              {{
                subscriberType == "max-yearly"
                  ? 2400 + credits?.topup - credits?.credits
                  : subscriberType == "max-monthly"
                    ? 200 + credits?.topup - credits?.credits
                    : 6 - credits?.credits
              }}
            </div>
          </div>
          <div class="p-2 border rounded-lg flex-grow">
            <h4 class="text-text-secondary">
              {{ $t("navbar.CreditsLeft", "CreditsUsed") }}
            </h4>
            <div
              class="bg-background-success text-text-success px-3 py-2 rounded-md mt-2"
            >
              {{ credits?.credits }}
            </div>
          </div>
        </div>
      </div>
    </PopoverContent>
  </Popover>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useMockupStore } from "@/datastore/module/mockup.js";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Icon } from "@iconify/vue";

const store = useMockupStore();

const subscriberType = computed(() => store?.subscriberType);
const credits = computed(() => store?.credits);
</script>
<style scoped>
.odometer {
  display: flex;
}

.digit-container {
  width: 1ch;
  height: 1em;
  overflow: hidden;
  position: relative;
}

.digit-roll {
  display: flex;
  flex-direction: column;
  transition: transform 1s ease-out;
}

.digit-roll span {
  height: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
